import { z } from 'zod';
/**
 * Flow Control Start v1 Configuration Validator
 * Start nodes don't require any configuration
 */
export const Flow_Control_Start_1_ConfigValidator = z.object({});
//# sourceMappingURL=flow-control-start-1.js.map